import styled from 'styled-components'

export const Link = styled.a`
    border-radius: 100px;
    margin-left: 10px;
`
